import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { HomeModule } from './home/home.module';
import { ShellModule } from './shell/shell.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MeetTheTeamModule } from '@app/meet-the-team/meet-the-team.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { ENV_PROVIDERS, environment } from '@env/environment';
import { ModalErrorModule } from '@app/components/modal-error/modal-error.module';
import { provideGoogleAnalytics, provideGoogleAnalyticsRouter } from '@hakimio/ngx-google-analytics';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

type ModuleType = typeof import('lottie-web/build/player/lottie_light');

export function playerFactory(): Promise<ModuleType> {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web/build/player/lottie_light');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule.forRoot(),
    NgbModule,
    CoreModule,
    SharedModule,
    ModalErrorModule,
    ShellModule,
    HomeModule,
    MeetTheTeamModule,
    RecaptchaV3Module,
    AppRoutingModule,
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaPublicKey },
    ...ENV_PROVIDERS,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideGoogleAnalytics(environment.googleAnalyticsKey),
    provideGoogleAnalyticsRouter(),
    provideLottieOptions({ player: playerFactory }),
    provideCacheableAnimationLoader(),
  ],
})
export class AppModule {}
